var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.003 6.384L10 10.382L17.997 6.384C17.9674 5.87444 17.7441 5.39549 17.3728 5.04523C17.0016 4.69497 16.5104 4.49991 16 4.5H4C3.48958 4.49991 2.99845 4.69497 2.62718 5.04523C2.25591 5.39549 2.0326 5.87444 2.003 6.384Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.618L10 12.618L2 8.618V14.5C2 15.0304 2.21071 15.5391 2.58579 15.9142C2.96086 16.2893 3.46957 16.5 4 16.5H16C16.5304 16.5 17.0391 16.2893 17.4142 15.9142C17.7893 15.5391 18 15.0304 18 14.5V8.618Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.612e4784fe498f985b6373876cbebce3.svg";
export { ForwardRef as ReactComponent };